import React, { useState, useRef, useEffect } from 'react';
import { Search, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useUiStore } from '../../store/uiStore';

const SearchBar: React.FC = () => {
  const navigate        = useNavigate();
  const { searchQuery, setSearchQuery } = useUiStore();
  const [local, setLocal]   = useState(searchQuery);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => { setLocal(searchQuery); }, [searchQuery]);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const q = local.trim();
    if (!q) return;
    setSearchQuery(q);
    navigate(`/search?q=${encodeURIComponent(q)}`);
    inputRef.current?.blur();
  };

  return (
    <form onSubmit={submit} className="flex w-full max-w-2xl">
      <div className="relative flex-1">
        <input
          ref={inputRef}
          type="search"
          value={local}
          onChange={(e) => setLocal(e.target.value)}
          placeholder="Search for products…"
          aria-label="Search products"
          className="input rounded-r-none border-r-0 pr-8 h-10"
        />
        {local && (
          <button
            type="button"
            onClick={() => setLocal('')}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
            aria-label="Clear search"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
      <button
        type="submit"
        className="bg-accent hover:bg-accent-hover px-4 rounded-r-lg flex items-center justify-center text-gray-900 transition-colors"
        aria-label="Submit search"
      >
        <Search className="w-5 h-5" />
      </button>
    </form>
  );
};

export default SearchBar;
